import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownProps {
  initialSeconds?: number;
  size?: 'md' | 'lg';
}
function Unit({
  value,
  label,
  size
}: {
  value: string;
  label: string;
  size: 'md' | 'lg';
}) {
  return <div className="flex flex-col items-center" data-id="element-58" data-mp="3l2ao8q717fzz">
      <span className={`tabular-nums font-black leading-none text-ivory ${size === 'lg' ? 'text-5xl sm:text-6xl' : 'text-3xl sm:text-4xl'}`} style={{
      color: "#E01E1E"
    }} data-id="element-59" data-mp="3q15doazi82t2">
        {value}
      </span>
      <span className="mt-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-muted" data-id="element-60" data-mp="3h18v8r3pk06g">
        {label}
      </span>
    </div>;
}
export function Countdown({
  initialSeconds = 84455,
  size = 'md'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(initialSeconds);
  return <div className="flex items-start gap-4 sm:gap-6" role="timer" aria-label={`Quedan ${hours} horas, ${minutes} minutos y ${seconds} segundos`} style={{
    alignItems: "center",
    justifyContent: "center",
    gap: "11px"
  }} data-id="element-61" data-mp="10degxgd42nqh">
      <Unit value={hours} label="hs" size={size} data-id="element-62" data-mp="xz3ly0ixv29u" />
      <span className={`font-black text-line ${size === 'lg' ? 'text-4xl sm:text-5xl' : 'text-2xl sm:text-3xl'}`} style={{
      color: "#E01E1E"
    }} data-id="element-63" data-mp="t2v9ww01fp6w">
        :
      </span>
      <Unit value={minutes} label="min" size={size} data-id="element-64" data-mp="12s54ciictjy6" />
      <span className={`font-black text-line ${size === 'lg' ? 'text-4xl sm:text-5xl' : 'text-2xl sm:text-3xl'}`} style={{
      color: "#E01E1E"
    }} data-id="element-65" data-mp="12sese0ju9h18">
        :
      </span>
      <Unit value={seconds} label="seg" size={size} data-id="element-66" data-mp="a4997i8fo03i" />
    </div>;
}